import React from 'react';
import { motion } from 'framer-motion';
import { Download, Calendar, HeartPulse } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8" data-id="element-116" />,
    title: 'Descarga Inmediata',
    desc: 'Obtén el eBook al instante después de la compra.'
  }, {
    icon: <Calendar className="w-8 h-8" data-id="element-117" />,
    title: 'Sigue el Plan',
    desc: 'Aplica las sustituciones simples en tu cocina, baño y dormitorio por 7 días.'
  }, {
    icon: <HeartPulse className="w-8 h-8" data-id="element-118" />,
    title: 'Siente la Diferencia',
    desc: 'Más energía, menos hinchazón y mejor descanso en pocos días.'
  }];
  return <section className="py-24 bg-cream relative" data-id="element-119">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-6" data-id="element-122">
            ¿Cómo Funciona?
          </h2>
          <p className="text-lg text-dark/70" data-id="element-123">
            Un proceso simple diseñado para no abrumarte.
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-12 md:gap-8 relative" data-id="element-124">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-sage-light -z-10" data-id="element-125"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center max-w-xs relative z-10" data-id="element-126">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center text-sage-dark shadow-md border-4 border-cream mb-6 relative" data-id="element-127">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-sage text-white rounded-full flex items-center justify-center font-bold text-sm shadow-sm" data-id="element-128">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-serif text-dark mb-3" data-id="element-129">
                {step.title}
              </h3>
              <p className="text-dark/70" data-id="element-130">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}